import type { PayloadAction } from '@reduxjs/toolkit'

import { createSlice } from '@reduxjs/toolkit'

interface State {
  attachment?: Attachment
  isOpen: boolean
}

export interface Attachment {
  mimeType: string
  id?: string
  name?: string
  data?: string
}

let initialState: State = {
  isOpen: false
}

let slice = createSlice({
  name: 'previewer',
  initialState,
  reducers: {
    open (state, action: PayloadAction<Attachment>) {
      state.attachment = action.payload
      state.isOpen = true
    },

    close (state) {
      state.attachment = undefined
      state.isOpen = false
    }
  }
})

export let { open, close } = slice.actions
export default slice.reducer
